<template>
    <button 
        v-if="showComponent && enabled"
        title="Install ERPeach"
        class="btn btn-link btn-sm"
        @click.prevent="install"
        style="text-decoration:none"
    >
        <i class="fa fa-download"></i>
    </button>
</template>


<script>
import checkPermissions from '../../mixins/checkPermissions';
export default {
    name:"ks-install-app-button",
    mixins: [checkPermissions],
    computed:{
        enabled(){
            return window.app.installPrompt && app.auth.user.lts ? true : false;
        }
    },
    methods:{
        async install(){
            try{
                const result = await window.app.installPrompt.prompt();
                console.log(`Install prompt was: ${result.outcome}`);
                window.app.installPrompt = null;
            }catch(err){
                console.log(err);
            }
        }
    }
}
</script>